export default __webpack_public_path__ + "static/identity-mock-m6-3e8b17aecc97ac81428a5b640944cced.png";